import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSalesforceConnection } from "@/features/salesforceIntegration/hooks/useSalesforceConnection";

/**
 * Salesforce連携完了画面（`/auth/success/on-salesforce`）。
 * コールバック側でトークン永続化の完了を確認した後にここへ遷移する。
 * 接続状態はコールバック側で更新済みのSWRキャッシュから即座に表示できる。
 */
export const SalesforceOauthSuccess: React.FC = () => {
  const { connection } = useSalesforceConnection();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 2,
      }}
    >
      <CheckCircleIcon color="success" sx={{ fontSize: 60 }} />
      <Typography variant="h6">Salesforceとの連携が完了しました</Typography>
      {connection?.salesforceOrgId && (
        <Typography variant="body2" color="text.secondary">
          接続先組織ID: {connection.salesforceOrgId}
        </Typography>
      )}
      <Link component={RouterLink} to="/account">
        設定画面に戻る
      </Link>
    </Box>
  );
};
